import React from 'react'
import DfbHeadline from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_headline'
import DfbImage from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_image'
import DfbRte from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_rte'
import DfbQuote from '@dfb/gatsby-dfb-theme/src/components/ui-kit/dfb_quote'
import Section from '@dfb/gatsby-dfb-theme/src/components/blocks/section'
import { People } from '../../types/types'

const MPeople = ({ data }) => {
  const { headline, people }: { headline: string; people: Array<People> } = data

  return (
    <Section baseClass="m-People" data={data} defaultPadding="large">
      <div className="m-People-wrapper">
        <div className="m-People-container">
          <div className="m-People-content">
            {headline && <DfbHeadline headline={headline} headline_level="h2" add_class="m-People-headline" />}

            {people?.map((person) => (
              <div className="m-People-people">
                {person.people_image?.[0] && <DfbImage image={person.people_image[0]} add_class="m-People-image" />}

                <DfbHeadline headline={person.people_name} headline_level="h3" add_class="m-People-name" />

                <DfbRte text={person.people_info} add_class="m-People-information" />

                <DfbQuote
                  text={person.people_quote[0].text}
                  quote_author={person.people_quote[0].quote_author}
                  quote_author_position={person.people_quote[0].quote_author_position}
                  add_class="m-People-quote"
                />

                {!!person?.people_accordions?.length && (
                  <>
                    <DfbHeadline headline="Eure Fragen an mich" headline_level="h3" />
                    <ol className="c-Accordion c-Accordion--numbers m-People-accordion">
                      {person?.people_accordions?.[0]?.accordion_element?.map((elem, index) => (
                        <li className="c-Accordion-item" data-item={index}>
                          <button className="c-Accordion-button">
                            <span className="c-Accordion-buttonTitle">{elem.accordion_title}</span>
                            <span className="c-Accordion-icon">
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                <path
                                  fill="currentColor"
                                  d="M12 1C5.9 1 1 5.9 1 12s4.9 11 11 11 11-4.9 11-11S18.1 1 12 1zm0 20c-5 0-9-4-9-9s4-9 9-9 9 4 9 9-4 9-9 9z"
                                />
                                <path className="horizontally" fill="currentColor" d="M6 11h12v2H6z" />
                                <path className="vertically" fill="currentColor" d="M13 6v12h-2V6z" />
                              </svg>
                            </span>
                          </button>
                          <div className="c-Accordion-content">
                            <DfbRte text={elem.accordion_text} add_class="c-Accordion-rte" />
                          </div>
                        </li>
                      ))}
                    </ol>
                  </>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </Section>
  )
}

export default MPeople
